module.exports = __webpack_public_path__ + "img/katarina_living_room_5.07f79150.jpg";